import { createSlice } from '@reduxjs/toolkit';

import { gu_deepCopy } from 'root/util/general-util';

export const MODULE_TYPE_STATE = {
    REGISTER: 'registerModule',
    USER_VERIFICATION: 'userVerificationModule',
    RESET_PASSWORD: 'resetPasswordModule',
    CRYPTO_ADDRESS: 'cryptoAddressModule',
    TURNSTILE: 'turnstileModule',
    LOGIN: 'loginModule',
    CHANGE_PASSWORD: 'changePasswordModule',
};
//defines the type of security validation
export const VERIFY_SECURITY_VALIDATION_TYPE = {
    CLOUDFLARE_TURNSTILE: 'CLOUDFLARE_TURNSTILE',
};

const initialState = {
    isPortalSettingsReducerLoaded: false,
    portalSettings: {},
    masterSwitch: {},
    masterSwitchFileEnable: false,
    [MODULE_TYPE_STATE.LOGIN]: {
        verify_security_validation: [],
        request_security_validation: [],
    },
    [MODULE_TYPE_STATE.USER_VERIFICATION]: {
        email_verification_feature: true,
        phone_verification_feature: true,
        verify_security_validation: [],
    },
    [MODULE_TYPE_STATE.RESET_PASSWORD]: {
        otp_feature: false,
        verify_security_validation: [],
        request_security_validation: [],
    },
    [MODULE_TYPE_STATE.CRYPTO_ADDRESS]: {
        otp_feature: false,
        verify_security_validation: [],
    },
    [MODULE_TYPE_STATE.TURNSTILE]: {
        site_key: '',
        temp_site_key: '',
    },
    [MODULE_TYPE_STATE.CHANGE_PASSWORD]: {
        otp_feature: false,
    },
};

export const portalSettingsSlice = createSlice({
    name: 'portal-settings',
    initialState,
    reducers: {
        setPortalSettings: (state, action) => {
            state.portalSettings = gu_deepCopy(action?.payload || {});
            state.isPortalSettingsReducerLoaded = true;
        },
        setMasterSwitchFileEnable: (state, action) => {
            state.masterSwitchFileEnable = action?.payload || false;
        },
        clearSiteKey: (state) => {
            // set for refresh
            state.turnstileModule = { ...state.turnstileModule, temp_site_key: state.turnstileModule.site_key, site_key: '' };
        },
        resetSitekey: (state) => {
            // set for refresh
            state.turnstileModule = { ...state.turnstileModule, site_key: state.turnstileModule.temp_site_key };
        },
        setSiteKey: (state, action) => {
            state.turnstileModule = { ...state.turnstileModule, site_key: action?.payload };
        },
    },
});

export const { setPortalSettings, setMasterSwitchFileEnable, clearSiteKey, resetSitekey, setSiteKey } = portalSettingsSlice.actions;

export default portalSettingsSlice.reducer;
